module.exports = __webpack_public_path__ + "media/images/site/main_image4-50894c7a53777c8a4db754745d04d509.jpg";